import * as actions from '../actions'

const defaultState = {
    generative_ai_stats: { data: null, error: null },
    generative_ai_tokens_volume: { data: [], error: null },
    generative_ai_cost_volume: { data: [], error: null }
}

// Reducer para estadísticas de AI Generativa (charts)
export default function generativeAIStats(state = defaultState, action) {
    switch (action.type) {
        case actions.GET_GENERATIVE_AI_STATS:
            if (!action.error) {
                // Actualizar cada gráfico con sus datos
                const newState = Object.assign({}, state)

                Object.keys(action.payload).forEach((chartId) => {
                    newState[chartId] = {
                        data: action.payload[chartId].data,
                        error: action.payload[chartId].error
                    }
                })

                return newState
            }
            // Marcar todos los gráficos con error
            return Object.keys(state).reduce((acc, key) => {
                acc[key] = Object.assign({}, state[key], {
                    error: (action.payload && action.payload.message) || 'Error desconocido'
                })
                return acc
            }, {})

        case actions.CLEAN_GENERATIVE_AI_STATS:
            return defaultState

        default:
            return state
    }
}
